<template>
  <div class="spinner-box" :class="{ button, low }">
    <div class="circle-border">
      <div class="circle-core" :style="{backgroundColor}"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    button: Boolean,
    low: Boolean,
    backgroundColor: {
      type: String,
      required: false,
      default: '#fff'
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes spin {
  from {
    transform: rotate(0);
  }
  to{
    transform: rotate(359deg);
  }
}

.spinner-box {
  width: 300px;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  &.low {
    width: 40px;
    height: 40px;

    .circle-border {
      width: 30px;
      height: 30px;
    }
  }
  &.button {
    width: 40px;
    height: 40px;

    .circle-border {
      width: 30px;
      height: 30px;
      background: #fff;
      background: linear-gradient(0deg, rgba(255, 204, 27, 0.1) 33%, #fff 100%);
    }
    .circle-core {
      background: rgb(255, 204, 27);
    }
  }
}

.circle-border {
  width: 150px;
  height: 150px;
  padding: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: rgb(255, 204, 27);
  background: linear-gradient(0deg, rgba(255, 204, 27, 0.1) 33%, rgb(255, 204, 27) 100%);
  animation: spin .8s linear 0s infinite;
}

.circle-core {
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 50%;
}
</style>
